export default __webpack_public_path__ + "static/media/3.009bfac5.jpg";